import React, { useEffect, useState } from "react";
import { imgURL } from "../../apiConfig";
import { Button, Table, Image } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from "react-bootstrap/Form";
import axios from "axios";

const AdminTution = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  // integrating post method
  const formdata = new FormData();
  const [OImage1, setOImage1] = useState("");
  const [HImage2, setHImage2] = useState("");
  const [OText1, setOText1] = useState("");
  const [IImage3, setIImage3] = useState("");
  const [IText3, setIText3] = useState("");
  const [HText2, setHText2] = useState("");

  const AdddTutionContent = async () => {
    formdata.set("OImage1", OImage1);
    formdata.set("HImage2", HImage2);
    formdata.set("OText1", OText1);
    formdata.set("IImage3", IImage3);
    formdata.set("IText3", IText3);
    formdata.set("HText2", HText2);

    try {
      const config = {
        url: "/user/TutionContent",
        method: "post",
        baseURL: "/api",
        headers: { "content-type": "multipart/form-data" },
        data: formdata,
      };
      let res = await axios(config);
      if (res.status === 200) {
        alert(res.data.success);
        getTutionContent();
        handleClose();
      }
    } catch (error) {
      console.log(error);
      alert(error.response.data.msg);
    }
  };
  //   //integrating get  method
  const [AddTutionContent, setAddTutionContent] = useState([]);
  const getTutionContent = async () => {
    try {
      let res = await axios.get(
        "/api/user/getTutionContent"
      );
      if (res.status === 200) {
        setAddTutionContent(res.data.getTutionContent);
      }
    } catch (error) {
      console.log(error);
    }
  };
  //delete method
  const [Data, setData] = useState("");
  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const handleShow2 = (item) => {
    setShow2(true);
    setData(item);
  };
  const DeleteTutionContent = async () => {
    try {
      const config = {
        url: "user/DeleteTutionContent/" + Data,
        method: "delete",
        baseURL: "/api/",
        header: { "content-type": "application/json" },
      };
      await axios(config).then((res) => {
        if (res.status === 200) {
          alert("successfully delete");
          getTutionContent();
          handleClose2();
        }
      });
    } catch (error) {
      console.log(error);
      alert(error.response.data.msg);
    }
  };
  //update method
  const [Data1, setData1] = useState("");
  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = (item) => {
    setShow1(true);
    setData1(item);
  };

  const editTutionContent = async (e) => {
    e.preventDefault();
    // if (!OImage1) {
    //   alert("Select the image");
    // } else {
    // formdata.set("OImage1", OImage1);
    // formdata.set("HImage2", HImage2);
    // formdata.set("OText1", OText1);
    // formdata.set("IImage3", IImage3);
    // formdata.set("IText3", IText3);
    // formdata.set("HText2", HText2);
    // formdata.set("id", Data1?._id);

    const obj = {
      OImage1: OImage1,
      HImage2: HImage2,
      OText1: OText1,
      IImage3: IImage3,
      IText3: IText3,
      HText2: HText2,
      id: Data1?._id,
    }

    try {
      const config = {
        url: "/user/editTutionContent",
        method: "put",
        baseURL: "/api",
        headers: { "content-type": "multipart/form-data" },
        data: obj,
      };
      await axios(config).then((res) => {
        if (res.status === 200) {
          alert("successfully Update");
          setOImage1("");
          setHImage2("");
          setIImage3("");
          handleClose1();
          getTutionContent();
        }
      });
    } catch (error) {
      console.log(error);
      alert(error.response.data.error);
    }
    // }
  };
  useEffect(() => {
    getTutionContent();
  }, []);
  console.log(AddTutionContent);
  return (
    <>

      <div className="add-gr">
        <div className="container">
          <div className="ad-b mt-4 mb-4">
            {AddTutionContent.length !== 0 ? (
              <></>
            ) : (
              <>
                <button className="btn btn-success" onClick={handleShow}>
                  Add Online/HomeTution/Institute Content
                </button>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="container">
        <div className="mo-gra mt-5">
          <Table striped bordered hover style={{ textAlign: "center" }}>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Online Image</th>
                <th>Online Description</th>

                <th>Home Tuition Image</th>
                <th>Home Tuition Description</th>

                <th>Institute Image</th>
                <th>Institute Description</th>

                <th>Edit</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {AddTutionContent?.map((item, i) => {
                return (
                  <tr>
                    <td>{++i}</td>
                    <td>
                      <Image
                        src={imgURL(`/TutionContent/${item?.OImage1}`)}
                        alt="pic"
                        style={{ width: "75px", height: "75px" }}
                      />
                    </td>

                    <td style={{ paddingTop: "20px" }} >

                      <p style={{ height: "100px", overflow: "hidden auto" }} className="card_text_p">
                        {item?.OText1}
                      </p>{" "}
                    </td>

                    <td>
                      <Image
                        src={imgURL(`/TutionContent/${item?.HImage2}`)}
                        alt="pic"
                        style={{ width: "75px", height: "75px" }}
                      />
                    </td>
                    <td style={{ paddingTop: "20px" }}>
                      <p style={{ height: "100px", overflow: "hidden auto" }} className="card_text_p">
                        {item?.HText2}
                      </p>
                    </td>

                    <td style={{ paddingTop: "20px" }}>
                      {" "}
                      <Image
                        src={imgURL(`/TutionContent/${item?.IImage3}`)}
                        alt="pic"
                        style={{ width: "75px", height: "75px" }}
                      />
                    </td>
                    <td style={{ paddingTop: "20px" }}>
                      <p style={{ height: "100px", overflow: "hidden auto" }} className="card_text_p">
                        {item?.IText3}
                      </p>
                    </td>

                    <td>
                      <div className="ad-b ">
                        <span>
                          <i
                            class="fas fa-edit"
                            style={{
                              fontSize: "20px",
                              color: "green",
                              paddingTop: "20px",
                            }}
                            onClick={() => handleShow1(item)}
                            title="edit"
                          ></i>
                        </span>
                      </div>
                    </td>
                    <td>
                      <i
                        class="fa fa-trash"
                        aria-hidden="true"
                        style={{
                          color: "red",
                          fontSize: "20px",
                          paddingTop: "20px",
                        }}
                        onClick={() => handleShow2(item?._id)}
                        title="delete"
                      ></i>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "#00a695" }}>
            {" "}
            Add Online/HomeTution/Institute Content
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FloatingLabel controlId="floatingInput" label=" Online Image">
            <Form.Control
              type="file"
              placeholder="name@example.com"
              className="rtyui_0"
              onChange={(e) => setOImage1(e.target.files[0])}
            />

          </FloatingLabel>{" "}
          <FloatingLabel controlId="floatingTextarea2" label="Enter  Online Description">
            <Form.Control
              as="textarea"
              placeholder="Leave a comment here"
              className="rtyui_0"
              onChange={(e) => setOText1(e.target.value)}
              style={{ height: '100px' }}
            />
          </FloatingLabel>

          <FloatingLabel controlId="floatingInput" label=" Home Tution Image">
            <Form.Control
              type="file"
              placeholder="name@example.com"
              className="rtyui_0"
              onChange={(e) => setHImage2(e.target.files[0])}
            />
          </FloatingLabel>{" "}
          <FloatingLabel controlId="floatingTextarea2" label="Enter Home Tution Description">
            <Form.Control
              as="textarea"
              placeholder="Leave a comment here"
              className="rtyui_0"
              onChange={(e) => setHText2(e.target.value)}
              style={{ height: '100px' }}
            />
          </FloatingLabel>

          <FloatingLabel controlId="floatingInput" label=" Institute Image">
            <Form.Control
              type="file"
              placeholder="name@example.com"
              className="rtyui_0"
              onChange={(e) => setIImage3(e.target.files[0])}
            />
          </FloatingLabel>{" "}
          <FloatingLabel controlId="floatingTextarea2" label="Enter Institute Description">
            <Form.Control
              as="textarea"
              placeholder="Leave a comment here"
              className="rtyui_0"
              onChange={(e) => setIText3(e.target.value)}
              style={{ height: '100px' }}
            />
          </FloatingLabel>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            style={{ backgroundColor: "#00a695", border: "none" }}
            onClick={AdddTutionContent}
          >
            Add
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={show1} onHide={handleClose1}>
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "#00a695" }}>
            {" "}
            Update Online/HomeTution/Institute Content
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FloatingLabel controlId="floatingInput" label=" Online Image">
            <Form.Control
              type="file"
              placeholder="name@example.com"
              className="rtyui_0"
              onChange={(e) => setOImage1(e.target.files[0])}
            />
          </FloatingLabel>{" "}
          <FloatingLabel controlId="floatingTextarea2" label="Enter  Online Description">
            <Form.Control
              as="textarea"
              placeholder="Leave a comment here"
              className="rtyui_0"
              onChange={(e) => setOText1(e.target.value)}
              style={{ height: '100px' }}
            />
          </FloatingLabel>
          <FloatingLabel controlId="floatingInput" label=" Home Tution Image">
            <Form.Control
              type="file"
              placeholder="name@example.com"
              className="rtyui_0"
              onChange={(e) => setHImage2(e.target.files[0])}
            />
          </FloatingLabel>{" "}
          <FloatingLabel controlId="floatingTextarea2" label="Enter Home Tution Description">
            <Form.Control
              as="textarea"
              placeholder="Leave a comment here"
              className="rtyui_0"
              onChange={(e) => setHText2(e.target.value)}
              style={{ height: '100px' }}
            />
          </FloatingLabel>
          <FloatingLabel controlId="floatingInput" label=" Institute Image">
            <Form.Control
              type="file"
              placeholder="name@example.com"
              className="rtyui_0"
              onChange={(e) => setIImage3(e.target.files[0])}
            />
          </FloatingLabel>{" "}
          <FloatingLabel controlId="floatingTextarea2" label="Enter Institute Description">
            <Form.Control
              as="textarea"
              placeholder="Leave a comment here"
              className="rtyui_0"
              onChange={(e) => setIText3(e.target.value)}
              style={{ height: '100px' }}
            />
          </FloatingLabel>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose1}>
            Close
          </Button>
          <Button
            style={{ backgroundColor: "#00a695", border: "none" }}
            onClick={(e) => editTutionContent(e)}
          >
            Update
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={show2} onHide={handleClose2}>
        <Modal.Header closeButton>
          <Modal.Title>Warning</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h3 style={{ color: "#c0392b" }}>Do You Really Want To Delete...</h3>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose2}>
            Close
          </Button>
          <Button variant="primary" onClick={DeleteTutionContent}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AdminTution;
